// utils/sanitizeInput.js

export const sanitizeInput = (value) => {
    if (typeof value !== "string") return "";
  
    return value
      .replace(/<script.*?>.*?<\/script>/gi, "") // Remove script tags
      .replace(/[<>]/g, "") // Remove angle brackets
      .replace(/['"`]/g, ""); // Remove quotes
    //  .trim(); // Remove extra spaces
  };
  